var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer-main-wrap"},_vm._l((_vm.pointers),function(pointer,idx){return _c('div',{staticClass:"pointer-item"},[_c('default-point',{ref:'pointer_' + pointer.id,refInFor:true,attrs:{"value":pointer.id,"active":_vm.active == pointer,"pointer":pointer},on:{"on-click":function($event){return _vm.onClick(pointer)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }